import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import PanelListDefaultGridEditable from 'Components/PanelListGridEditable/PanelListDefaultGridEditable';
import { clearLocalStorage, getFromLocalStorage, saveToLocalStorage } from 'Components/AutomaticallyListedAttributesGrid/AutomaticallyListedAttributesGrid';
import arTN from 'date-fns/esm/locale/ar-TN/index.js';

const ExternalProductionOperations = ({
    productionsEmployeesSelecteds,
    operationsDaySelecteds,
    setOperationsDaySelecteds,
    isOpen
}) => {
    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [rowsInsertingOperations, setRowsInsertingOperations] = useState([]);
    const [rowsInsertingOperationsDefault, setRowsInsertingOperationsDefault] = useState([]);

    const [idOperationsEmployee, setIdOperationsEmployee] = useState(null);
    const [dsOperation, setDsOperation] = useState(null);
    const [timePerOperation, setTimePerOperation] = useState(null);
    const [quantityOperations, setQuantityOperations] = useState(null);
    const [pricePerOperation, setPricePerOperation] = useState(null);
    const [isChecked, setIsChecked] = useState(null);
    const [username, setUsername] = useState(null);
    const [updateDate, setUpdateDate] = useState(null);

    const attributeListDetail = [
        {
            name: "id", value: idOperationsEmployee, setter: setIdOperationsEmployee
        },
        {
            name: "dsOperation", value: dsOperation, setter: setDsOperation
        },
        {
            name: "timePerOperation", value: timePerOperation, setter: setTimePerOperation, readOnly: true
        },
        {
            name: "quantityOperations", value: quantityOperations, setter: setQuantityOperations
        },
        {
            name: "pricePerOperation", value: pricePerOperation, setter: setPricePerOperation
        },
        {
            name: "isChecked", value: isChecked, setter: setIsChecked
        },
        { name: "username", value: username, setter: setUsername },
        { name: "dtUpdate", value: updateDate, setter: setUpdateDate },
    ];

    const attributeListGrid = [
        {
            name: "id", value: idOperationsEmployee, setter: setIdOperationsEmployee,
            style: {
                border: 'none',
                outline: 'none',
                resize: 'none',
                marginLeft: '4px'
            },
        },
        {
            name: "dsOperation", value: dsOperation, setter: setDsOperation, minGridWidth: '300px', maxGridWidth: '300px', style: {
                border: 'none',
                outline: 'none',
                resize: 'none'
            },
        },
        {
            name: "timePerOperation", value: timePerOperation, setter: setTimePerOperation, style: {
                border: 'none',
                outline: 'none',
                resize: 'none'
            },
        },
        {
            name: "quantityOperations", value: quantityOperations, setter: setQuantityOperations,
            isMandatory: 'S', isMandatoryGrid: 'S',
            style: {
                border: 'none',
                outline: 'none',
                resize: 'none'
            },
        },
        {
            name: "pricePerOperation", value: pricePerOperation, setter: setPricePerOperation,
            isMandatory: 'S', isMandatoryGrid: 'S',
            style: {
                border: 'none',
                outline: 'none',
                resize: 'none'
            },
        },
        {
            name: "isChecked", value: isChecked, setter: setIsChecked, style: {
                border: 'none',
                outline: 'none',
                resize: 'none'
            },
        }
    ];

    const [recordsProductionOperationsByUserId, setRecordsProductionOperationsByUserId] = useState(null);
    const [attributesDetailProductionOperationsPanel, setAttributesDetailProductionOperationsPanel] = useState(null);
    const [loadingProductionOperationsPanel, setLoadingProductionOperationsPanel] = useState(null);

    // Só busca com o painel aberto; a grid depende do colaborador selecionado (salvar/excluir já recarregam)
    useEffect(() => {
        if (!isOpen) {
            return;
        }
        reloadListProductionOperations()
    }, [productionsEmployeesSelecteds, isOpen]);

    useEffect(() => {
        if (!isOpen) {
            clearLocalStorage('operationList');
        }
    }, [isOpen]);

    function getDetailInformation() {
        if (operationsDaySelecteds && operationsDaySelecteds.length > 0) {
            fetchDataDetail(operationsDaySelecteds[0]);
        } else {
            fetchDataDetail(0);
        }
    }

    const fetchDataDetailInserting = async (operationsDaySelected) => {
        const parameters = { externalEmployeeDayId: operationsDaySelected }
        const productionOperations = await ExecuteAxios.api('get', `/external-production-operation/get-for-insert/`, { params: parameters })
        setRowsInsertingOperations(productionOperations)

        if (productionOperations) {
            saveToLocalStorage('externalProductionOperations', setRowsInsertingOperations, setRowsInsertingOperationsDefault, productionOperations,);
        }
    };

    const fetchDataDetail = async (operationsDaySelected) => {
        const parameters = { id: operationsDaySelected }
        const productionOperations = await ExecuteAxios.api('get', `/external-production-operation/detail/`, { params: parameters })
        if (productionOperations) {
            setAttributesDetailProductionOperationsPanel(productionOperations)
            ApplyAttributes.applyAttributes(productionOperations, attributeListDetail)
        }

        if (!operationsDaySelecteds || operationsDaySelecteds.length === 0) {
            ResetVariables.resetVariables(attributeListDetail);
        }
    };

    useEffect(() => {
        if (!isOpen) {
            return;
        }
        getDetailInformation();
    }, [operationsDaySelecteds, isOpen]);

    async function getProductionOperationsRecords(productionsDayIdSelected) {
        const parameters = { externalEmployeeDayId: productionsDayIdSelected }
        const productionOperations = await ExecuteAxios.api('get', `/external-production-operation/grid/`, { params: parameters });
        setRecordsProductionOperationsByUserId(productionOperations);
        RemoveIdsNotFound.remove(productionOperations, setOperationsDaySelecteds, productionsDayIdSelected)
    }

    const getProductionOperationsPanelListOrDetail = () => {
        if (!inserting && !updating) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={setOperationsDaySelecteds}
                    idsSelected={operationsDaySelecteds}
                    data={recordsProductionOperationsByUserId}
                />
            )
        } else if (inserting) {
            return (
                <PanelListDefaultGridEditable
                    rowsBackend={rowsInsertingOperations}
                    setRowsBackend={setRowsInsertingOperations}
                    updateHelperOperationList={null}
                    attributeList={attributeListGrid}
                    localStorageName={'externalProductionOperations'}
                    height={'calc(88% - 65px)'}
                    dsOperation={dsOperation}
                />
            )
        } else if (updating) {
            return (
                <AutomaticallyListedAttributes
                    list={attributesDetailProductionOperationsPanel}
                    readOnlyAttributes={false}
                    attributeList={attributeListDetail}
                />
            )
        }
    }

    async function postEmployeesOperations() {
        try {
            setLoadingProductionOperationsPanel(true)
            const operationList = mappedOperations();
            const response = await ExecuteAxios.api('post', `/external-production-operation/`, operationList);

            if (response) {
                await reloadListProductionOperations()
            }

            return response
        } finally {
            setLoadingProductionOperationsPanel(false)
        }
    }

    const mappedOperations = () => {
        const operationList = getFromLocalStorage('externalProductionOperations');
        return operationList.map(operation => {
            const productOperationId = operation.constructorList.find(item => item.field === 'id')?.argument;
            const quantityOperations = operation.constructorList.find(item => item.field === 'quantityOperations')?.argument;
            const pricePerOperation = operation.constructorList.find(item => item.field === 'pricePerOperation')?.argument;
            const isChecked = operation.constructorList.find(item => item.field === 'id')?.checked;
            const externalEmployeeDayId = productionsEmployeesSelecteds[0]

            return {
                productOperationId,
                quantityOperations,
                pricePerOperation,
                isChecked,
                externalEmployeeDayId
            };
        });
    };

    async function putEmployeesOperations() {
        try {
            setLoadingProductionOperationsPanel(true)
            const response = await ExecuteAxios.api('put', `/external-production-operation/`, {
                externalEmployeeDayId: productionsEmployeesSelecteds[0],
                id: operationsDaySelecteds[0],
                quantityOperations: quantityOperations,
                pricePerOperation: pricePerOperation,
                isChecked: isChecked
            });

            if (response) {
                await reloadListProductionOperations()
            }

            return response
        } finally {
            setLoadingProductionOperationsPanel(false)
        }
    }

    async function reloadListProductionOperations() {
        if (productionsEmployeesSelecteds && productionsEmployeesSelecteds.length === 1) {
            await getProductionOperationsRecords(productionsEmployeesSelecteds[0])
            fetchDataDetailInserting(productionsEmployeesSelecteds[0])
        } else {
            await getProductionOperationsRecords(0)
        }
    }

    async function deleteEmployeesOperations() {
        try {
            setLoadingProductionOperationsPanel(true)
            const response = await ExecuteAxios.api('delete', `/external-production-operation/`, {
                params: {
                    ids: operationsDaySelecteds.join(",")
                }
            });

            if (response) {
                await reloadListProductionOperations()
            }

            return response
        } finally {
            setLoadingProductionOperationsPanel(false)
        }
    }

    return (
        <LoadingIndicator loaded={!loadingProductionOperationsPanel}>
            <Panel
                style={{ display: 'flex', height: '100%', flexDirection: 'column' }}
                setInserting={setInserting}
                setUpdating={setUpdating}
                inserting={inserting}
                updating={updating}
                enableNewRecord={true}
                putFunction={putEmployeesOperations}
                canNewRecord={productionsEmployeesSelecteds && productionsEmployeesSelecteds.length === 1}
                enableEdit={true}
                canEdit={operationsDaySelecteds && operationsDaySelecteds.length == 1}
                postFunction={postEmployeesOperations}
                deleteFunction={deleteEmployeesOperations}
                canDelete={operationsDaySelecteds && operationsDaySelecteds.length > 0}
                enableDelete={true}
                canViewCRUD={true}
                localStorageName={'externalProductionOperations'}
                isGrid={inserting}
                attributeList={inserting ? attributeListGrid : attributeListDetail}
                needCheckedCheckboxToValidateMandatoryGrid={true}
                recordsSelected={operationsDaySelecteds}
                dataListedAttributes={attributesDetailProductionOperationsPanel}
                onUpdateIdSelected={setOperationsDaySelecteds}
            >
                {getProductionOperationsPanelListOrDetail()}
            </Panel>
        </LoadingIndicator >
    );
};

export default ExternalProductionOperations;


